import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

@Injectable()
export class CustomerSitesService {
    constructor(private http: HttpClient) { }
    uploadFiles(data) {
        return this.http.post(environment.apiURL + 'student/upload', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    /* fetchDisposalLocation() {
        return this.http.get(environment.apiURL + 'disposallocation/list').pipe(
            tap((response: any) => {
                return response;
            })
        );
    } */
    fetchDisposalLocation(data?: any) {
        let val = {};
        if (!data || data == undefined || data == null) {
            data = {}
            val = {};
        } else {
            val = {
                ParentId: data
            };
        }
        return this.http.post(environment.apiURL + 'disposallocation/list', val).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
   
    companyList() {
        return this.http.get(environment.apiURL + 'company/list').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    fetchTipLocation() {
        return this.http.get(environment.apiURL + 'tiplocation/list').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    createTipLocation(data) {
        return this.http.post(environment.apiURL + 'tiplocation/create', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    departmentList(value) {
        return this.http.get(environment.apiURL + 'department/list?companyId=' + value).pipe(
            tap((response: any) => {
                return response;
            })
        );

    }

    getTipDetails(id) {
        return this.http.get(environment.apiURL + 'tiplocation/' + id).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    updateTipLocation(data) {
        return this.http.post(environment.apiURL + 'tiplocation/update', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    deleteStudent(id) {
        return this.http.delete(environment.apiURL + 'student/delete/' + id).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }



    // updateUser(data): Observable<any> {
    //     return this.http.post(environment.apiURL + 'user/update', data).pipe(
    //         tap((res: any) => {
    //             return res;
    //         })
    //     );
    // }
    create(registerForm) {
        return this.http.post(environment.apiURL + 'user/create', registerForm).pipe(tap((res) => res));
    }
    // fetchUser() {
    //     return this.http.get(environment.apiURL + 'user/list').pipe(tap((res) => res));
    // }
    deleteSite(userID) {
        return this.http.delete(environment.apiURL + 'tiplocation/delete/' + userID).pipe(tap((res) => res));
    }
}
